export default function FieldValueItem({ fieldName, fieldValue }) {
  return (
    <>
      {fieldName && <b>{`${fieldName}: `}</b>}
      {fieldValue ? (
        <>
          {fieldValue}
          <br />
        </>
      ) : (
        <br />
      )}
    </>
  );
}
